import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { TokenService } from '../../services/state-management/token.service/token.service';

export const authGuardToCheckUserLoggedInStatus: CanActivateFn = (route, state) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);
  const isLoggedIn = tokenService.isLoggedIn();
  const isAuthPage = ['/auth/login', '/auth/signup'].includes(state.url);

  if (isLoggedIn) {
    if (isAuthPage) {
      router.navigate(['/gallery']); // Redirect to dashboard if logged in
      return false;
    }
    return true;
  }
  if (isAuthPage) return true; // Allow access to login/signup pages if not logged in

  router.navigate(['/auth/login']); // Redirect to login if not authenticated
  return false;
};
